import { FormBase } from 'core/components';

export default class ChangeShippingForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'assignedWarehouse',
					label: 'CHANGESHIPPINGVIEW.WAREHOUSE',
				},
				{
					name: 'assignedCarrierService',
					label: 'CHANGESHIPPINGVIEW.CARRIERSERVICE',
					rules: 'required',
				},
				{
					name: 'useBuyShipping',
					label: 'CHANGESHIPPINGVIEW.USEBUYSHIPPING',
					rules: 'required',
					default: null,
				},
				{
					name: 'voidLabelOptionId',
					label: 'CHANGESHIPPINGVIEW.VOIDLABELOPTION',
				},
				{
					name: 'ignoreDeliverByDate',
					label: '',
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/ChangeShippingForm.js